// extracted by mini-css-extract-plugin
module.exports = {"shift":"OfferWatchMobileShift_shift__Yf2uc"};